export const CONTRACT_STATUS = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    ARCHIVED: 'ARCHIVED',
};
export const CONTRACT_STATUS_LABELS = {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    EXPIRED: 'Expired',
    ARCHIVED: 'Archived',
};
/** How included hours reset over the life of a contract. */
export const BILLING_PERIOD = {
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY',
    WHOLE_TERM: 'WHOLE_TERM',
};
export const BILLING_PERIOD_LABELS = {
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    YEARLY: 'Yearly',
    WHOLE_TERM: 'Whole contract term',
};
/** What happens to unused included hours when a billing period ends. */
export const CARRY_FORWARD_RULE = {
    NONE: 'NONE',
    FULL: 'FULL',
    CAPPED: 'CAPPED',
};
export const CARRY_FORWARD_RULE_LABELS = {
    NONE: 'Unused hours expire',
    FULL: 'Carry every unused hour forward',
    CAPPED: 'Carry forward up to a cap',
};
/** Every movement on a contract's hour ledger. Minutes are signed: credits +, debits −. */
export const HOUR_LEDGER_KIND = {
    INCLUDED: 'INCLUDED',
    PURCHASED: 'PURCHASED',
    CARRY_FORWARD: 'CARRY_FORWARD',
    EXPIRED: 'EXPIRED',
    CONSUMED: 'CONSUMED',
    RESERVED: 'RESERVED',
    RELEASED: 'RELEASED',
    ADJUSTMENT: 'ADJUSTMENT',
};
export const HOUR_LEDGER_KIND_LABELS = {
    INCLUDED: 'Included hours',
    PURCHASED: 'Purchased hours',
    CARRY_FORWARD: 'Carried forward',
    EXPIRED: 'Expired at period end',
    CONSUMED: 'Used by approved work',
    RESERVED: 'Reserved',
    RELEASED: 'Reservation released',
    ADJUSTMENT: 'Manual adjustment',
};
export const PAYMENT_MILESTONE_STATUS = {
    PENDING: 'PENDING',
    INVOICED: 'INVOICED',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
};
export const PAYMENT_MILESTONE_STATUS_LABELS = {
    PENDING: 'Pending',
    INVOICED: 'Invoiced',
    PAID: 'Paid',
    CANCELLED: 'Cancelled',
};
/** Days before the end date from which a contract counts as "expiring soon". */
export const CONTRACT_EXPIRY_WARNING_DAYS = 30;
//# sourceMappingURL=contract-status.js.map